import React, { useEffect, useState } from "react";
import get from "lodash/get";

import StoryCard5 from "../../molecules/story-card5";
import StoryCard4 from "../../molecules/story-card4";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import { AdContainer } from "../../ads";
import Separator from "../../atoms/separator";

import "./three-col-four-stories.m.css";
import { filterStory } from "../../helper/api";

const ThreeColFourStories = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const collections = collection.items.filter((item) => item.type === "collection");

  if (!collections.length) {
    return null;
  }

  const [isMobile, setMobile] = useState(false);
  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  const desktopAdUnitId = get(collection, ["associated-metadata", "desktopAdUnitId"], null);

  const AdCard = ({ id, mobile }) => {
    if (index !== 1) return null;
    return (
      <>
        {isMobile ? (
          <div styleName="ad-wrapper" className="hide-desktop">
            <AdContainer AdClassName="standard-336x280" id={id} mobile={mobile} />
          </div>
        ) : null}
      </>
    );
  };

  const mobileAdUnitId1 = get(collection, ["associated-metadata", "mobileAdUnitId1"], null);
  const mobileAdUnitId2 = get(collection, ["associated-metadata", "mobileAdUnitId2"], null);
  const mobileAdUnitId3 = get(collection, ["associated-metadata", "mobileAdUnitId3"], null);

  const renderCollection = (collection, collectionIndex) => {
    const stories = filterStory(collection);
    return (
      <div styleName="collection-wrapper" key={collectionIndex}>
        <CollectionTitleHeader collection={collection} index={index} defaultBorder={!isMobile} />
        <div styleName="story-wrapper">
          {stories?.splice(0, 1).map((item, index) => (
            <StoryCard5 story={item} key={item.id} lineClamp={2} />
          ))}
          {stories?.splice(0, 3).map((item, index) => (
            <React.Fragment key={item.id}>
              <StoryCard4 story={item} key={item.id} />
              {collectionIndex === 0 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156938221-0" mobile={mobileAdUnitId1} />
              ) : null}
              {collectionIndex === 1 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156970809-0" mobile={mobileAdUnitId2} />
              ) : null}
              {collectionIndex === 2 && index === 2 ? (
                <AdCard id="div-gpt-ad-1680156998073-0" mobile={mobileAdUnitId3} />
              ) : null}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  };
  if (location.pathname === "/assembly-elections-2023") {
    collections[0].slug = "telangana-assembly-elections-2023";
    collections[1].slug = "madhya-pradesh-assembly-elections-2023";
    collections[2].slug = "rajasthan-assembly-elections-2023";
  }
  return (
    <div styleName="border-wrapper">
      <div styleName="wrapper">
        {collections.splice(0, 2).map((item, index) => renderCollection(item, index))}
        {desktopAdUnitId ? (
          <div styleName="ad-wrapper">
            <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1680156228599-0" desktop={desktopAdUnitId} />
          </div>
        ) : (
          collections.splice(0, 1).map((item) => renderCollection(item, 2))
        )}
      </div>
      <Separator />
    </div>
  );
};

export default ThreeColFourStories;
